import type * as SpringRoll from "springroll";

export abstract class BaseCaptionRenderer extends PIXI.Container implements SpringRoll.IRender {
    protected _size!: PIXI.Point;

    public start(): void {
        // override
    }

    public stop(): void {
        // override
    }

    public lineBegin(pLine: {content: string}): void {
        // override
    }

    public lineEnd(): void {
        // override
    }

    public onResize(pSize: PIXI.Point): void {
        this._size = pSize;
    }
}
